<!-- eslint-disable space-before-function-paren -->
<!-- eslint-disable prefer-rest-params -->
<!-- eslint-disable no-shadow -->
<!-- eslint-disable no-restricted-syntax -->
<!-- eslint-disable func-names -->
<!-- eslint-disable no-prototype-builtins -->
<script>
    import ApexCharts from 'apexcharts/dist/apexcharts';
    import merge from 'lodash/merge';
    import cloneDeep from 'lodash/cloneDeep';
    import debounce from 'lodash/debounce';

    export default {
        props: {
            options: {
                type: Object,
            },
            type: {
                type: String,
            },
            series: {
                type: Array,
                required: false,
                default: () => [],
            },
            width: {
                type: [String, Number],
                default: '100%',
            },
            height: {
                type: [String, Number],
                default: 'auto',
            },
        },
        data() {
            return {
                chart: null,
            };
        },
        computed: {
            chartType() {
                return this.type || this.options.chart.type || 'line';
            },
            chartDefaultSeries() {
                return this.chartType === 'pie' ? [] : [{ name: '', data: [] }];
            },
        },
        methods: {
            validateWidthHeight(value) {
                // Jeśli wartość jest liczbą, zwróć ją bez zmian (ApexCharts interpretuje ją jako piksele)
                if (typeof value === 'number') {
                    return value;
                }
                // Jeśli wartość jest ciągiem znaków
                if (typeof value === 'string') {
                    // Wyrażenie regularne do sprawdzania 'px' lub '%'
                    const lengthRegex = /^\d+(\.\d+)?(px|%)$/;
                    // Jeśli wartość pasuje do wyrażenia regularnego, zwróć ją bez zmian
                    if (lengthRegex.test(value)) {
                        return value;
                    }
                    // Jeśli wartość jest liczbą w postaci stringu, konwertuj na liczbę (piksele)
                    if (!Number.isNaN(value)) {
                        return Number.parseInt(value, 10);
                    }
                }
                // Jeśli wartość nie jest prawidłowa, możesz zwrócić domyślną wartość lub rzucić wyjątek
                return null;
            },
            init() {
                const type = this.chartType;
                let series = this.series;
                if (!series?.length) series = this.options.series;
                if (!series?.length) series = this.chartDefaultSeries; // Default data to prevent error
                const newOptions = {
                    chart: {
                        type,
                        height: this.validateWidthHeight(this.height),
                        width: this.validateWidthHeight(this.width),
                        events: {},
                    },
                    series,
                };

                Object.keys(this.$listeners).forEach(evt => {
                    newOptions.chart.events[evt] = this.$listeners[evt];
                });

                const config = cloneDeep(merge({}, this.options, newOptions));
                this.chart = new ApexCharts(this.$el, config);
                return this.chart.render();
            },
            isObject(item) {
                return item && typeof item === 'object' && !Array.isArray(item) && item != null;
            },
            refresh() {
                this.destroy();
                return this.init();
            },
            destroy() {
                this.chart.destroy();
            },
            updateSeries(newSeries, animate) {
                return this.chart.updateSeries(newSeries, animate);
            },
            updateOptions(newOptions, redrawPaths, animate, updateSyncedCharts) {
                return this.chart.updateOptions(cloneDeep(newOptions), redrawPaths, animate, updateSyncedCharts);
            },
            toggleSeries(seriesName) {
                return this.chart.toggleSeries(seriesName);
            },
            showSeries(seriesName) {
                this.chart.showSeries(seriesName);
            },
            hideSeries(seriesName) {
                this.chart.hideSeries(seriesName);
            },
            appendSeries(newSeries, animate) {
                return this.chart.appendSeries(newSeries, animate);
            },
            resetSeries() {
                this.chart.resetSeries();
            },
            zoomX(min, max) {
                this.chart.zoomX(min, max);
            },
            toggleDataPointSelection(seriesIndex, dataPointIndex) {
                this.chart.toggleDataPointSelection(seriesIndex, dataPointIndex);
            },
            appendData(newData) {
                return this.chart.appendData(newData);
            },
            addText(options) {
                this.chart.addText(options);
            },
            addImage(options) {
                this.chart.addImage(options);
            },
            addShape(options) {
                this.chart.addShape(options);
            },
            dataURI(options) {
                return this.chart.dataURI(options);
            },
            setLocale(localeName) {
                return this.chart.setLocale(localeName);
            },
            addXaxisAnnotation(options, pushToMemory) {
                this.chart.addXaxisAnnotation(options, pushToMemory);
            },
            addYaxisAnnotation(options, pushToMemory) {
                this.chart.addYaxisAnnotation(options, pushToMemory);
            },
            addPointAnnotation(options, pushToMemory) {
                this.chart.addPointAnnotation(options, pushToMemory);
            },
            removeAnnotation(id, options) {
                this.chart.removeAnnotation(id, options);
            },
            clearAnnotations() {
                this.chart.clearAnnotations();
            },
        },
        render(createElement) {
            return createElement('div');
        },
        beforeMount() {
            window.ApexCharts = ApexCharts;
        },
        mounted() {
            this.init();
        },
        async created() {
            const watched = ['type', 'width', 'height'];
            watched.forEach(prop => {
                this.$watch(prop, () => {
                    this.refresh();
                });
            });

            const debouncedUpdateOptions = debounce(async options => {
                if (!this.chart && options) {
                    this.init();
                } else {
                    await this.updateOptions(options);
                    this.$emit('optionsUpdate', false);
                }
            }, 600);

            const debouncedUpdateSeries = debounce(async series => {
                if (!this.chart && series) {
                    this.init();
                } else {
                    await this.updateSeries(series);
                    this.$emit('seriesUpdate', false);
                }
            }, 600);

            this.$watch('options', async (options, oldOptions) => {
                if (JSON.stringify(options || {}) !== JSON.stringify(oldOptions || {})) {
                    if (Array.isArray(options.series) && options.series.length === 0) {
                        // eslint-disable-next-line no-param-reassign
                        options.series = this.chartDefaultSeries; // Default data to prevent error
                    }
                    this.$emit('optionsUpdate', true);
                    debouncedUpdateOptions(options);
                }
            });

            this.$watch('series', async (series, oldSeries) => {
                if (JSON.stringify(series || []) !== JSON.stringify(oldSeries || [])) {
                    this.$emit('seriesUpdate', true);
                    debouncedUpdateSeries(series);
                }
            });
        },

        beforeUnmount() {
            if (!this.chart) {
                return;
            }
            this.destroy();
        },
    };
</script>
